var UrlHelper = /** @class */ (function () {
    function UrlHelper() {
    }
    UrlHelper.prototype.paramsUrl = function (url) {
        var searchParams = new URLSearchParams(url);
        var params = {};
        searchParams.forEach(function (value, key) {
            params[key] = value;
        });
        return params;
    };
    UrlHelper.prototype.getAppName = function (url) {
        var urlObject = new URL(url);
        var urlPathNameObject = urlObject.pathname.split("/");
        return urlPathNameObject[1];
    };
    return UrlHelper;
}());
export { UrlHelper };
